// extracted by mini-css-extract-plugin
module.exports = {"lock-icon":"HeaderCtas_lock-icon__UNILR","welcome-heading":"HeaderCtas_welcome-heading__LlL9v"};